let THE_SCRIPT = function () {
    const $onReady = require('public/js/lib/on-ready');

    (function () {
        $onReady({
            rp$, window,
            label: 'interactive_garage',
            fn: function () {
                iFrameResize({log:false, checkOrigin:false}); 
            }
        });
    })();
};

try {
    // Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
    if (typeof __CURRENT_SCRIPT__ === 'undefined') {
        throw new Error('__CURRENT_SCRIPT__ is not defined');
    }
    var __CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
    THE_SCRIPT();
}